import React from 'react';
import {
  Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Paper, Typography,
  TableFooter,
  Box
} from '@mui/material';

const SimpleTable = ({ title, data, columns,totalData }) => {

  return (
    <TableContainer component={Paper} sx={{ maxWidth: 700, mx: 'auto', mt: 4 }}>
      {title && (
        <Typography variant="h6" align="center" sx={{ my: 2 }}>
          {title}
        </Typography>
      )}
       <Box
      sx={{
        width: '100%',
        overflowX: 'auto', // IMPORTANT for horizontal scroll
      }}
    >
      <Table>
        <TableHead>
          <TableRow>
            {columns.map((col) => (
              <TableCell key={col.key} align={col.align || 'left'}>
                <strong>{col.label}</strong>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
         <TableBody>
          {data.map((row, idx) => (
            <TableRow key={idx}>
              {columns.map((col) => (
                <TableCell key={col.key} align={col.align || 'left'}>
                  {row[col.key]?.toLocaleString?.() ?? row[col.key]}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>

        {totalData && (
          <TableFooter>
            <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
              {columns.map((col, index) => (
                <TableCell
                  key={col.key}
                  align={col.align || 'left'}
                  sx={{ fontWeight: 'bold', color: 'primary.main' }}
                >
                  {totalData[col.key]?.toLocaleString?.() ?? totalData[col.key]}
                </TableCell>
              ))}
            </TableRow>
          </TableFooter>
        )}
      </Table>
      </Box>
    </TableContainer>
  );
};

export default SimpleTable;
